/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Two_Fa_Use_Recovery_CodeInputs */

const en_two_fa_use_recovery_code = /** @type {(inputs: Two_Fa_Use_Recovery_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use a recovery code`)
};

const nl_two_fa_use_recovery_code = /** @type {(inputs: Two_Fa_Use_Recovery_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een herstelcode gebruiken`)
};

/**
* | output |
* | --- |
* | "Use a recovery code" |
*
* @param {Two_Fa_Use_Recovery_CodeInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const two_fa_use_recovery_code = /** @type {((inputs?: Two_Fa_Use_Recovery_CodeInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Two_Fa_Use_Recovery_CodeInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_two_fa_use_recovery_code(inputs)
	return en_two_fa_use_recovery_code(inputs)
});